import axios from 'axios';

import * as auth from './auth';

export function baseUrl() {
  let port = 80;
  if (window.location.port === '8080') {
    port = 8080;
  }
  if (window.location.port === '8090') {
    port = 8080;
  }
  const base = `http://${window.location.hostname}:8080/api/v1/`;
  return base;
}

export function baseWebUrl() {
  let subdir = 'web-portal/';
  if (window.location.port === '8080') {
    subdir = '';
  }
  if (window.location.port === '8090') {
    subdir = '';
  }
  const base = `http://${window.location.hostname}:${window.location.port}/${subdir}`;
  return base;
}

const ajax = axios.create({
  baseURL: baseUrl(),
});

ajax.interceptors.request.use((config) => {
  // eslint-disable-next-line
  config.headers.common.Authorization = `Bearer ${auth.getAccessToken()}`;
  return config;
});

ajax.interceptors.response.use(
  response => response,
  (error) => {
    if (error.response.status === 401) { // Unauthorized
      // console.log('A 401 error occurred, redirecting to login page...');
      auth.clearAccessToken();
      window.location.reload();
    } else {
      // console.log('An error occurred but no need to redirect to login page (it was not a 401 error).');
    }
    return error;
  },
);

export default ajax;
